<template>
  <div class="container-superset">
    <div id="superset-container"></div>
  </div>
</template>

<script>
import TokenService from "@/services/resources/TokenService";

const tokenService = TokenService.build();

export default {
  name: "SupersetDashboard",
  data() {
    return {
      resourceId: "5e6e21f5-e842-4ff8-b985-e3b7dec697c4",
      api_key: null,
      loading: false,
    };
  },
  mounted() {
    if(this.$store.getters.getProfile.id == 5) {
      this.fetchApiKey();
    } else {
      window.location.href = "https://adm.voompcreators.com.br/dashboard";
    }
  },
  methods: {
    fetchApiKey() {
      this.loading = true;
      tokenService
        .search()
        .then((response) => {
          this.api_key = response.api_key;
          this.loadDashboard();
        })
        .catch((err) => {
          console.log(err);
        })
    },
    async loadDashboard() {
      const mountPoint = document.getElementById("superset-container");

      if (mountPoint) {
        mountPoint.innerHTML = "";
      }

      if (mountPoint) {
        const iframe = document.createElement("iframe");
        iframe.src = `https://stvoompprdbs.blob.core.windows.net/voomp-static/superset/index.html?resource_id=${this.resourceId}&api-key=${this.api_key}`;
        iframe.width = "100%";
        iframe.height = "100%";
        iframe.border = "0";
        iframe.style.overflow = "hidden";
        iframe.style.border = "0";
        mountPoint.appendChild(iframe);
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.container-superset {
  width: 100%;
  height: 100%;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
}

#superset-container {
  width: 100%;
  height: calc(100vh);
  border: none;
  overflow: hidden;
}

iframe {
  width: 100%;
  height: 100%;
  border: 0;
  overflow: hidden;
}

iframe html, body {
  overflow: hidden;
}
</style>
